import React, { Component } from "react";
import { connect } from "react-redux";
import { earlyVotingTargetToggle } from "../../actions/earlyVotingActions";
import _ from "lodash";
import VotingTargetToggle from "../debate/VotingTargetToggle";
import VotingUserResult from "../debate/VotingUserResult";

class List extends Component {
  checkVotingResult = (tev, uid) => {
    let yes = tev.yes || [];
    let no = tev.no || [];

    yes = yes.filter(someId => someId === uid);
    no = no.filter(someId => someId === uid);

    if (yes.length) return true;
    else if (no.length) return false;
    else return null;
  };

  list = (cCode, users, theEarlyVoting) => {
    const absent = theEarlyVoting.absent || [];
    return (
      <table className="table">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">이름</th>
            <th scope="col">투표 대상</th>
            <th scope="col">투표 결과</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(users)
            .filter(([uid, user]) => user.currentClass === cCode)
            .sort(([uid1, user1], [uid2, user2]) =>
              user1.name < user2.name ? -1 : 1
            )
            .map(([uid, user], idx) => {
              // const result =
              return (
                <tr key={idx}>
                  <th scope="row">{idx + 1}</th>
                  <td> {user.name} </td>
                  <td>
                    <VotingTargetToggle
                      cCode={cCode}
                      uid={uid}
                      target={!absent.includes(uid)}
                      updateTarget={this.props.earlyVotingTargetToggle}
                    />
                  </td>
                  <td>
                    {absent.includes(uid) ? (
                      "N/A"
                    ) : (
                      <VotingUserResult
                        result={this.checkVotingResult(theEarlyVoting, uid)}
                      />
                    )}
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
    );
  };

  render() {
    const { cCode } = this.props.location.params;
    const { users } = this.props;
    const theEarlyVoting = this.props.earlyVoting[cCode] || {};
    return (
      <div className="row">
        <div className="col-12">{this.list(cCode, users, theEarlyVoting)}</div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  users: state.users,
  location: state.location,
  earlyVoting: state.earlyVoting
});

export default connect(
  mapStateToProps,
  { earlyVotingTargetToggle }
)(List);
